export var Y_FIELD = '$$stock-range$$';
export var TREND_FIELD = 'trend';
export var TREND_UP = 'up';
export var TREND_DOWN = 'down';
export var TREND_COLOR = ['#ef5350', '#26a69a'];
/** tooltip 配置 */

export var DEFAULT_TOOLTIP_OPTIONS = {
  showTitle: false,
  showMarkers: false,
  showCrosshairs: true,
  shared: true,
  crosshairs: {
    type: 'xy',
    follow: true
  },
  itemTpl: '<li class="g2-tooltip-list-item" data-index={index}>' + '<span style="background-color:{color};" class="g2-tooltip-marker"></span>' + '{name}{value}</li>'
};